import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';

export default function PromptModal({
  show,
  onClose,
  onConfirm,
  title = 'Input Required',
  message,
  placeholder = 'Enter value...',
  type = 'warning'
}) {
  const [inputValue, setInputValue] = useState('');

  if (!show) return null;

  const getColors = () => {
    switch (type) {
      case 'warning':
        return {
          icon: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          button: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
        };
      case 'danger':
        return {
          icon: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          button: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
        };
      default:
        return {
          icon: 'linear-gradient(135deg, #A08EA8 0%, #7D6882 100%)',
          button: 'linear-gradient(135deg, #A08EA8 0%, #7D6882 100%)'
        };
    }
  };

  const colors = getColors();

  const handleConfirm = () => {
    if (!inputValue.trim()) {
      return;
    }
    onConfirm(inputValue);
    setInputValue('');
    onClose();
  };

  const handleClose = () => {
    setInputValue('');
    onClose();
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        animation: 'fadeIn 0.2s ease-in'
      }}
      onClick={handleClose}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          animation: 'slideUp 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          background: colors.icon,
          margin: '0 auto 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white'
        }}>
          <MessageSquare size={32} />
        </div>

        {/* Title */}
        <h3 style={{
          margin: '0 0 12px 0',
          fontSize: '20px',
          fontWeight: '600',
          color: '#111827',
          textAlign: 'center'
        }}>
          {title}
        </h3>

        {/* Message */}
        {message && (
          <p style={{
            margin: '0 0 20px 0',
            fontSize: '15px',
            color: '#6b7280',
            textAlign: 'center',
            lineHeight: '1.6'
          }}>
            {message}
          </p>
        )}

        {/* Input */}
        <textarea
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={placeholder}
          autoFocus
          rows={4}
          style={{
            width: '100%',
            padding: '12px',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '14px',
            marginBottom: '24px',
            outline: 'none',
            resize: 'vertical',
            fontFamily: 'inherit'
          }}
          onFocus={(e) => e.target.style.borderColor = '#A08EA8'}
          onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
        />

        {/* Buttons */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px'
        }}>
          <button
            onClick={handleClose}
            style={{
              padding: '12px 24px',
              background: '#f3f4f6',
              color: '#374151',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#e5e7eb';
              e.target.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#f3f4f6';
              e.target.style.transform = 'scale(1)';
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={handleConfirm}
            disabled={!inputValue.trim()}
            style={{
              padding: '12px 24px',
              background: inputValue.trim() ? colors.button : '#d1d5db',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: inputValue.trim() ? 'pointer' : 'not-allowed',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => inputValue.trim() && (e.target.style.transform = 'scale(1.02)')}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
